import { importTypes } from '../../config/import';
import { checkAccounts } from './checkAccounts';
import { checkCompanyAccounts } from './checkCompanyAccounts';
import { checkMeters } from './checkMeters';
import { checkOwners } from './checkOwners';

export const checkDataForPreview = {
  [importTypes.owners]: checkOwners,
  [importTypes.personalAccounts]: checkAccounts,
  [importTypes.personalAccountsByCompanies]: checkCompanyAccounts,
  [importTypes.individualMeters]: checkMeters,
};
